<template lang="pug">
  app-modal.modalInformacao(
    titulo="Solicitar Acesso",
    :width="width"
    :isDespacho='true'
    @closeModal="closeModal()"
  )
    template(slot="body")
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
        :tituloDocumento="tituloDocumento"
      )
      div.extra-margin-top
        validation-observer(ref='validation' tag='form')
          el-row.margin-top
            el-col(:span="24")
              app-label.mt-20(
                label="Justificativa:",
                :required="true"
              )
              validation-provider(rules="required", v-slot="{ errors }")
                app-editor-texto.input(
                  :value="mensagem",
                  @onTextChange="onTextChange"
                  :class="{'erro' : errors.length}"
                  ref="editorTexto"
                )
                span.help.erro( v-if="errors.length" ) {{ errors[0] }}
          el-row.margin-top
            p.label.mt-20 Anexos mensagem
          el-row.margin-top
            validation-provider(v-slot="{ errors }")
              app-anexo(
                :id="'upload-informacao-solicitar'"
                @removeFile="removeFile",
                @uploadFile="uploadFile"
                :files="anexos"
                scope="anexos",
                v-model="anexos",
                :errors="errors",
                :exibirDownload="false"
              )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal()"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small",
          @click="sendMessage()"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import moment from 'moment'
import axios from '@/utils/api'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal.vue'
import AppAnexo from '@/components/AppAnexo'
import messages from '@/constants/messages'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton.vue'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf.vue'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppLabel,
    AppAnexo,
    AppDownloadArquivo,
    AppEditorTexto,
    AppActionButton,
    AppModalVisualizaPdf
  },

  mixins: [AppNotificacao],
  props: {
    width: {
      type: Number,
      default: 850
    },
    idProcesso: {
      required: false
    },
    setor: {
      required: false
    },
    idsProcessosSelecionados: {
      type: Array,
      required: false
    },
    idSolicitacao: {
      type: Number,
      required: false,
      default: null
    }
  },

  data () {
    return {
      moment,
      usuario: null,
      anexoList: [],
      prazo: null,
      assunto: null,
      mensagem: null,
      anexos: [],
      tituloModal: '',
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: ''
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),
    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },
    removeFile (file) {
      const arquivo = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(arquivo, 1)
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    closeModal () {
      this.$emit('closeModal')
    },
    onTextChange (value) {
      this.mensagem = value
    },

    async sendMessage () {
      if (!await this.checkValidacao()) {
        return
      }
      const today = new Date()
      today.setDate(today.getDate() + 10)
      const obj = {
        setorRequerido: 'JURIDICO',
        despacho: null,
        dataVencimento: moment(today).format('YYYY-MM-DD'),
        conversa: {
          assunto: 'Solicitar Acesso',
          processo: {
            id: null
          },
          mensagemList: [
            {
              conteudo: this.mensagem,
              anexoList: this.anexos,
              dataLimiteResposta: today
            }
          ]
        },
        idsProcessos: this.idsProcessosSelecionados,
        isSolicitacaoAcesso: true,
        id: this.idSolicitacao
      }

      axios({
        method: 'POST',
        url: `solicitarInformacao/create`,
        error: true,
        data: obj
      }).then(() => {
        this.idsProcessosSelecionados = []
        this.$emit('limpar')
        this.closeModal()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'A solicitação de acessa foi enviada para o setor responsável. Acompanha o status na caixa solicitações.'
        )
        this.$emit('solicitacaoEnviada')
      }).catch((e) => {
        let mensagemErro = ''
        if (e.erros !== null && e.erros.length > 0) {
          e.erros.forEach(mensagem => {
            mensagemErro += mensagem + ' '
          })
        } else {
          mensagemErro = messages.ERROR_MESSAGE
        }
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          mensagemErro
        )
      })
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },

    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },

    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.mt-20 {
  margin-top: 20px;
}

.extra-margin-top {
  margin-top: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/acompanharProcessos/components/AppModalSolicitarAcesso.vue